<template>
  <div class="parent">
    <div class="title">
      <VTitle page-title="已上课程"></VTitle>
    </div>

    <div class="content">
      <div class="contentchild" v-infinite-scroll="loadMore"
           infinite-scroll-disabled="disable"
           infinite-scroll-distance="10">
        <VCoureseShowCell v-for="obj,index in arrayData" :obj="obj" :key="index">

        </VCoureseShowCell>
        <div v-show="loadingState != 1" class="bottom">
          <!-- loadingState == 2 显示加载动画状态-->
          <mt-spinner v-show="loadingState == 2" type="fading-circle" color="#cba164"></mt-spinner>
          <span v-text="stateText"></span>
        </div>
      </div>


    </div>

    <div class="goBack">
      <VGoBackBtn></VGoBackBtn>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import VTitle from '../../components/VTitle.vue';
  import VCoureseShowCell from '../../components/VCoureseShowCell.vue';
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import netTool from '../../api/netTool';
  import Vue from 'vue';
  import { InfiniteScroll, Toast } from 'mint-ui';
  Vue.use(InfiniteScroll);
  export default{
    data () {
      return {
        arrayData: [],
        currentPage: 0,
        totalPage: {},
        disable: false,
        loadingState: 1 // 1-正常隐藏状态 2-加载状态 3-到底状态 4-nothing状态 5-网络情况差
      };
    },
    components: {VTitle, VCoureseShowCell, VGoBackBtn},
    methods: {
      loadMore () {
        this.currentPage++;
        this.getData();
      },
      getData () {
        // {'page': this.currentPage}
        netTool.completeCourse(this.currentPage).then(response => {
          // if (response.errno === '0') {
            if (this.currentPage === 1) {
              this.arrayData = response.data.list;
            } else {
              for (let i = 0; i < response.data.list.length; i++) {
                this.arrayData.push(response.data.list[i]);
              }
            }
            this.currentPage = response.data.pageNum;
            this.totalPage = response.data.pageSize;
            this.disable = this.currentPage >= this.totalPage;
            if (this.disable) {
              if (this.arrayData.length === 0) {
                this.setLoadingState(4);
              } else {
                this.setLoadingState(3);
              }
            } else {
              // 还有下一页正常隐藏状态为1，后来报错修改为加载状态状态为2
              this.setLoadingState(1);
            }
          // } else {
          //   Toast({message: response.message, position: 'middle', duration: 3000});
          // }
        }).catch(e => {
          this.setLoadingState(5);
        });
      },
      setLoadingState(state) {
        this.loadingState = state;
      }
    },
    computed: {
      stateText() {
        let text = '';
        switch (this.loadingState) {
          case 1:
            text = '';
            break;
          case 2:
            text = '加载中...';
            break;
          case 3:
            text = '到底了...';
            break;
          case 4:
            text = '暂无记录';
            break;
          case 5:
            text = '请检查您的网络';
            break;
        }
        return text;
      }
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';

  .parent {
    @include bg-img('../../assets/img/common/Bg');
    width: px2rem(750);
  }

  .title {
    margin-left: px2rem(160);
    float: left;
    padding-top: px2rem(80);
    text-align: center;
  }

  .content {
    @include bg-img('../../assets/img/parentRecord/coursebackground');
    width: px2rem(671);
    height: px2rem(953);
    margin-top: px2rem(120);
    margin-left: px2rem(40);
    .contentchild {
      padding-top: px2rem(20);
      margin-left: px2rem(65);
      margin-right: px2rem(65);
      margin-bottom: px2rem(65);
      width: px2rem(536);
      height: px2rem(800);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }
  }



  .parent:after {
    display: block;
    clear: both;
    content: '';
  }

  .bottom {
    margin-top: px2rem(10);
    height: px2rem(70);
    line-height: px2rem(70);
    text-align: center;
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: px2rem(30);
      &:nth-child(2) {
        margin-left: px2rem(20);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CompletedCourse.vue?189ed5c5